module.exports = __webpack_public_path__ + "img/hefty.1281b0d9.svg";